import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { getFilesQueryKey } from './getFiles';
import { getFoldersQueryKey } from './getFolders';
import { getRootFilesQueryKey } from './getRootFiles';

const url = `${PREFIX_URL}/library/:libraryItemId/rename-versioned`;

type RenameResponse = { success: boolean };
type RenameDTO = {
  name: string;
  libraryItemId: number;
  version: number;
};

export const rename = ({ name, libraryItemId, version }: RenameDTO): Promise<RenameResponse> => {
  const URL = generateRoutePath(url, { libraryItemId });

  return axios.put(URL, { name, version });
};

type UseRenameOptions = {
  config?: MutationConfig<typeof rename>;
};

export const useRename = ({ config }: UseRenameOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (response) => {
      if (!response.success) {
        return;
      }

      queryClient.invalidateQueries({ queryKey: getFilesQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getFoldersQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getRootFilesQueryKey.list });
    },
    mutationFn: (props) => rename(props),
  });
};
